import { Alert, Box } from '@mui/material';
import styled from '@emotion/styled';
import { FormControlLabel } from '@mui/material/';
import { BASIC_BORDER_RADIUS, FIELD_BACKGROUND, HIGH_EMPHASIS } from '../../themes/tokens';

export const YearlyInputSwitch = styled(FormControlLabel)`
  margin: 0 0 48px 0;
`;

export const HistoricalDataAlert = styled(Alert)`
  background-color: ${FIELD_BACKGROUND};
  border-radius: ${BASIC_BORDER_RADIUS};
  display: flex;
  align-items: center;
  color: ${HIGH_EMPHASIS};

  svg {
    color: ${HIGH_EMPHASIS};
  }
`;

export const HistoricalContentWrapper = styled(Box)`
  overflow: auto;
  height: 60vh;
`;
